import React, { useEffect, useState } from 'react'
import { doctors } from '../../Assets/dummyDoc'
import Header from '../Core/Header'
import Cookies from "js-cookie";
import { getAlldoctors, requestDoctormapping } from '../../service/operations/api_methods';
import { toast } from 'sonner';

const FindDoctors = () => {
     const token = Cookies.get("token")
     const[list,setList]=useState(doctors)

        const handlegetAllDoctors=async()=>{
             try {
                 const res= await getAlldoctors(token)
                 console.log(res);
                 if(res.status===200){
                     setList(res.data.data)
                 }
                 
             } catch (error) {
                 console.log(error);
                 
             }
         }

         const handleReqauestMapping=async(id)=>{
            try {
                let data={
                    doctor_user_id:id
                }
                const res= await requestDoctormapping(token,data)
                console.log(res);
                if(res.status===200){
                    toast.success(res.data.message)
                    handlegetAllDoctors()
                }
                
            } catch (error) {
                console.log(error);
                toast.error(error?.message||"Failed to send request")
                
            }
         }
     
         useEffect(() => {
             handlegetAllDoctors()
           
         }, [])
  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-between",padding:"6px"}}>
            <p style={{color:"white"}}>All registered Doctors </p>
            <input placeholder='Search Doctor by Adhaar'
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white"
            }}/>
                 <p style={{fontSize:"14px",padding:"5px",borderRadius:"6px",backgroundColor:"#fefefe",cursor:"pointer"}}>Register New</p>
            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            list.map((item)=>(
                <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>{!item?.alreadyMapped &&
                <p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}
                    onClick={()=>handleReqauestMapping(item.user.id)}>
                      { item.requestStatus?item.requestStatus: "Add to Assign"}
                        </p>}
                    <img  src={"http://192.168.29.250:7001"+item?.user?.profile_image}
                     style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div className="no-scrollbar"
                    style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%",overflowX:"auto"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item?.user?.first_name} {item?.user?.last_name}</p>
                          <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"500",color:"#d65d3eff"}}>{item?.user?.email}</span>
                            <span style={{fontSize:'14px',fontWeight:"500",color:"#6fa0d8ff"}}>{item?.user?.primary_number}</span></p>
                       
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"500",color:"#d65d3eff"}}>Age:{item?.user?.dob}</span>
                            <span style={{fontSize:'14px',fontWeight:"500",color:"#6fa0d8ff"}}>{item?.specialist_type}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item?.license_number}</span>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#5456d6ff"}}>Reg:{item.Registered}</span></p>
                       
                        
                     </div>

                    </div>
            ))
            }

        </div>

      </section>
    </div>
  )
}

export default FindDoctors
